import { mapState } from 'vuex';
import InstallationFeatures from '@/components/InstallationFeatures';

export default {
  computed: {
    ...mapState(['config']),
  },
  methods: {
    installApp(id, type, {
      isFromRepo, link, name, image, version, installationTicket, showSuccessConfirm = true,
    } = {}) {
      return new Promise(async (resolve, reject) => {
        if (!this.$store.getters.isDeviceLinked) {
          this.$confirm(this.$t('GO_TO_LINK_QUESTION')).then(() => {
            this.$router.push('/link');
          });
          reject();
          return;
        }

        const features = await this.getFeaturesConfig().catch((error) => {
          reject(error);
          throw error;
        });

        this.$api.installApp({
          id, type, features, isFromRepo, link, name, image, version, installationTicket,
        })
          .then(() => {
            if (showSuccessConfirm) {
              this.$confirm(this.$t('INSTALL_APP_CONFIRMATION'))
                .catch(() => {
                  this.$router.push('/my/status');
                });
            }
          })
          .catch(([errorCode, errorMessage]) => {
            this.$notify({
              type: 'error',
              text: errorMessage,
            });

            let message = '';
            let redirectLink = '';
            switch (errorCode) {
              case 'ERROR_FREE_DEVELOPER_UNSUPPORTED_IOS_VERSION':
                message = 'PLUS_OBTAIN_CONFIRM';
                redirectLink = '/my/buy';
                break;
              default:
                break;
            }
            if (message && redirectLink) {
              this.$confirm(this.$t(message)).then(() => this.goToLink(redirectLink));
              return;
            }

            if (redirectLink) {
              this.goToLink(redirectLink);
            }
          })
          .finally(resolve);
      });
    },
    async getFeaturesConfig() {
      if (this.config.ask_for_installation_options !== 'yes') {
        return {};
      }

      const features = await this.$api.getInstallFeatures();
      const config = await new Promise((resolve, reject) => {
        this.$modal.show(InstallationFeatures, {
          features,
          resolve,
          reject,
        }, {
          classes: 'features-modal',
          height: 'auto',
          width: '100%',
          maxWidth: 600,
          scrollable: true,
          clickToClose: false,
        });
      });

      return config;
    },
    goToLink(url) {
      if (/^\//.test(url)) {
        this.$router.push(url);
        return;
      }

      window.open(url, '_blank');
    },
  },
};
